import {type Module} from 'vuex';
import application from './application';
import mail from './mail';
import pipeline from './pipeline';

const module: Module<null, RootState> = {
    namespaced: true,
    modules: {
        pipeline,
        application,
        mail,
    },
};

export default module;
